// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"f50a3b20","49":"7f7c36fb","175":"4e78f43e"}[chunkId] + ".chunk.css";
};